import { useMutation } from '@apollo/react-hooks';
import { Formik, Form, FormikHelpers } from 'formik';
import gql from 'graphql-tag';
import { useState } from 'react';
import { Button, Form as BForm, Modal } from 'react-bootstrap';
import { TextInput } from './common';
import { normalizeText } from './common/helpers';
import * as Yup from 'yup';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/modals.css';

const passwordResetMut = gql`
  mutation resetPassword($email: String!) {
    resetPassword(email: $email)
  }
`;

interface Values {
  email: string;
}

interface props {
  showModal: boolean;
  closeModal: () => void;
  done: () => void;
}

export default function ResetPassword({
  showModal = false,
  closeModal,
  done,
}: props) {
  const [error, setError] = useState<string>('');

  const [resetPassword] = useMutation(passwordResetMut);

  function handleCloseModal() {
    setError('');
    closeModal();
  }

  function handleDone() {
    setError('');
    done();
  }

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        contentClassName="ec-modal-content"
      >
        <Modal.Header className="ec-modal-header" closeButton>
          <Modal.Title className="ec-modal-title">
            Trouble Logging In?
          </Modal.Title>
        </Modal.Header>
        <p className="ec-modal-new-to-evichat">
          Enter your email and we'll send you a link to get back into your
          account.
        </p>
        <Formik
          initialValues={{
            email: '',
          }}
          validationSchema={Yup.object({
            email: Yup.string()
              .email('Invalid email address')
              .trim()
              .max(254)
              .required('Required'),
          })}
          onSubmit={async (
            values: Values,
            { setSubmitting }: FormikHelpers<Values>
          ) => {
            resetPassword({
              variables: {
                email: normalizeText(values.email) || '',
              },
            })
              .then(() => {
                setSubmitting(false);
                handleDone();
              })
              .catch((err) => {
                setError(
                  'Sorry, please try again. Contact Evichat if the error persists.'
                );
                console.log(err);
              });
          }}
        >
          {({ errors, isSubmitting }) => (
            <Form>
              <Modal.Body>
                <BForm.Group controlId="formBasicEmail">
                  <TextInput
                    label="Email"
                    name="email"
                    type="text"
                    inputMode="email"
                    autoComplete="email"
                  />
                </BForm.Group>

                <BForm.Text className="ec-modal-error-msg ec-modal-login-error-msg">
                  <p>{error}</p>
                </BForm.Text>
              </Modal.Body>
              <Modal.Footer className="ec-modal-footer">
                <Button
                  variant="primary"
                  type="submit"
                  disabled={isSubmitting}
                  className="ec-modal-reset-password"
                >
                  Send Login Link
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
